import { Box, styled } from '@mui/material';

export const FilterBtnCounterStyle = styled(Box)(({ theme }) => ({
  width: '14px',
  height: '14px',
  lineHeight: '12px',
  fontSize: '10px',
  padding: '2px 4px',
  color: theme.palette.case.neutral.n0,
  backgroundColor: theme.palette.case.neutral.n400,
  borderRadius: '50%',
  display: 'flex',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  left: '12px',
  top: '-5px',
  zIndex: '2',
  cursor: 'pointer',
}));
